import React from 'react';
import classNames from 'classnames/bind';
import { enhancedConnect } from "../../../../utils";
import styles from "./styles.pcss";
import { StepsSlideContext } from "../../context";
var cx = classNames.bind(styles);
var _SlidePopup = function _SlidePopup(_ref) {
  var bottom = _ref.bottom,
    children = _ref.children,
    left = _ref.left,
    right = _ref.right,
    top = _ref.top;
  var _React$useContext = React.useContext(StepsSlideContext),
    isActive = _React$useContext.isActive;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('slide-popup', isActive && 'active'),
    style: {
      bottom: bottom,
      left: left,
      right: right,
      top: top
    },
    "data-t-id": "components-SlidePopup"
  }, children);
};
export var SlidePopup = enhancedConnect()(_SlidePopup);